import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

import { selectTours, emptyCart } from "../../app/features/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../../components/MainLayout";
import { Box, Button, Container, Typography } from "@mui/material";
import ProductCard2 from "../../components/ProductCard2";
import './styles.css'
import bookingUrl from '../../assets/images/booking.png'
import { ReactComponent as Share } from "../../assets/icons/share.svg"
import { useScreenDetector } from "../../hooks/useScreenDetector";
import BookingProductCard from "./BookingProductCard";
import axios from 'axios';
import { useParams } from "react-router-dom";

const STEP2_FORM_STORAGE_KEY = 'checkout-step2-form';

const Booking = () => {
    const { t } = useTranslation(['voucher']);
    const { i18n } = useTranslation();
    var cartTours = useSelector(selectTours);
    const dispatch = useDispatch();
    const { isMobile } = useScreenDetector()

    const { confirmation } = useParams();

    const { REACT_APP_BASE_URL, REACT_APP_CDN_URL } = process.env
    const token = localStorage.getItem('token');

    const [dataBooking, setData] = useState([]);

    const handleShareClick = () => {
        const urlVoucher = `${REACT_APP_CDN_URL}/voucher_${confirmation}${i18n.language == 'en' ? '_en-US' : ''}.pdf`; // URL del voucher

        // Mensaje a enviar
        const mensaje = `${t('message1')}
${t('message2')}
${t('message3')}

${urlVoucher}

${t('message4')}`;

        // Codificar el mensaje para la URL
        const mensajeCodificado = encodeURIComponent(mensaje);

        // Número de teléfono (incluye el código de país, sin "+")

        // Generar el enlace
        const linkWhatsapp = `https://wa.me/?text=${mensajeCodificado}`;

        // Abrir el enlace en una nueva pestaña
        window.open(linkWhatsapp, '_blank');
    };

    useEffect(() => {
        axios.get(`${REACT_APP_BASE_URL}/index.php?r=api/booking/get&confirmation=${confirmation}`,
            {
                headers: {
                    'x-authorization-token': token
                }
            })
            .then(response => {
                setData(response.data);
                dispatch(emptyCart());
                localStorage.removeItem(STEP2_FORM_STORAGE_KEY);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    return (
        <MainLayout>
            <Box id="background-container">
                <Container
                    sx={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}
                >
                    <Box
                        sx={{
                            my: '30px',
                            p: { xs: '15px 0px', md: '15px 40px' },
                            borderRadius: '8px',
                            width: '100%',
                            backgroundColor: '#FFFFFF'
                        }}
                    >
                        <Box sx={{
                            display: 'block',
                            textAlign: 'center',
                            mb: '40px'
                        }}>
                            <img
                                alt="trekzy.com"
                                src={bookingUrl}
                                style={{
                                    width: '124px',
                                    height: '124px'
                                }}
                            />
                            <Typography
                                variant="h5"
                                color="secondary"
                                sx={{
                                    fontSize: '16px',
                                    mb: '10px'
                                }}
                            >
                                {t('booking-confirmation')}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="p"
                                sx={{
                                    fontSize: '12px',
                                    mb: '10px'
                                }}
                            >
                                {/* Lorem ipsum dolor sit amet consectetur. Felis sit tempus email@email.com Dui tortor orci fusce facilisi. Fames lorem at pulvinar pulvinar et mi est sed */}
                            </Typography>
                            <Box sx={{
                                display: { xs: 'grid', md: 'block' }
                            }}>
                                <Button
                                    target="_blank"
                                    href={`${REACT_APP_CDN_URL}/voucher_${confirmation}${i18n.language == 'en' ? '_en-US' : ''}.pdf`}
                                    variant="outlined"
                                    sx={{
                                        color: 'primary.main'
                                    }}
                                >{t('download-pdf')}</Button>
                                <Button
                                    onClick={handleShareClick}
                                    color="secondary"
                                    variant="contained"
                                    sx={{
                                        ml: { xs: '0px', md: '15px' },
                                        mt: { xs: '15px', md: 0 }
                                    }}
                                >
                                    {t('share')}&nbsp;
                                    <Share />
                                </Button>
                            </Box>
                        </Box>
                        <Typography
                            variant="h5"
                            color="secondary"
                            sx={{
                                fontSize: '16px',
                                mb: '10px'
                            }}
                        >
                            {t('purchase-summary')}
                        </Typography>
                        {dataBooking.map(item => (<ProductCard2 key={item.name} data={item} showPrice={false} isCart={true} />))}
                        <Box sx={{
                            display: { xs: 'grid', md: 'block' },
                            textAlign: 'center',
                            mt: '20px',
                            mb: '10px'
                        }}>
                            <Button
                                href="/"
                                color="primary"
                                variant="contained"
                            >{t('Continue navigating')}</Button>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </MainLayout>
    )
}

export default Booking;
